import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuthForCheckout } from '@router/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuthForCheckout))
